module.exports = __webpack_public_path__ + "img/41-config-formularios-lista.2fa929a1.png";